export const GLOBAL_DELETE = "GLOBAL_DELETE";
export const GLOBAL_CANCEL = "GLOBAL_CANCEL";
export const GLOBAL_UNKNOWN = "GLOBAL_UNKNOWN";

export const GLOBAL_TEST_ENVIRONMENT_BANNER_TEST_MODE = "GLOBAL_TEST_ENVIRONMENT_BANNER_TEST_MODE";
export const GLOBAL_TEST_ENVIRONMENT_BANNER_LIVE_TEST_MODE = "GLOBAL_TEST_ENVIRONMENT_BANNER_LIVE_TEST_MODE";
export const GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_MESSAGE = "GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_MESSAGE";
export const GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_BUTTON = "GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_BUTTON";
